import { useState } from 'react';

interface CreateMailTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (newMailTemplate: any) => void;
}

const CreateMailTemplateModal = ({ isOpen, onClose, onCreate }: CreateMailTemplateModalProps) => {
  const [previewMode, setPreviewMode] = useState('desktop'); // 'desktop' or 'mobile'
  const [newMailTemplate, setNewMailTemplate] = useState({
    name: '',
    subject: '',
    body: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setNewMailTemplate(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onCreate(newMailTemplate);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-1000">
      <div className="gothic-panel w-full max-w-md">
        <h2 className="gothic-heading">Create New Mail Template</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="name" className="block gothic-text-silver mb-1">Template Name</label>
            <input
              id="name"
              name="name"
              type="text"
              value={newMailTemplate.name}
              onChange={handleChange}
              className="gothic-input w-full"
              required
            />
          </div>
          <div>
            <label htmlFor="subject" className="block gothic-text-silver mb-1">Subject</label>
            <input
              id="subject"
              name="subject"
              type="text"
              value={newMailTemplate.subject}
              onChange={handleChange}
              className="gothic-input w-full"
              required
            />
          </div>
          <div>
            <label htmlFor="body" className="block gothic-text-silver mb-1">Body (HTML)</label>
            <textarea
              id="body"
              name="body"
              value={newMailTemplate.body}
              onChange={handleChange}
              className="gothic-input w-full"
              rows={10}
            ></textarea>
            <div className="mt-4">
              <h3 className="gothic-heading">Preview:</h3>
              <div className="flex justify-center mb-2">
                <button
                  type="button"
                  onClick={() => setPreviewMode('desktop')}
                  className={`gothic-button ${previewMode === 'desktop' ? 'gothic-button-primary' : 'bg-gray-700 border-gray-600'} mr-2`}
                >
                  Desktop View
                </button>
                <button
                  type="button"
                  onClick={() => setPreviewMode('mobile')}
                  className={`gothic-button ${previewMode === 'mobile' ? 'gothic-button-primary' : 'bg-gray-700 border-gray-600'}`}
                >
                  Mobile View
                </button>
              </div>
              <div
                className={`gothic-panel p-4 border border-gray-700 bg-gray-900 overflow-auto ${previewMode === 'mobile' ? 'w-80 mx-auto' : 'w-full'}`}
                style={{ maxWidth: previewMode === 'mobile' ? '320px' : '100%' }}
                dangerouslySetInnerHTML={{ __html: newMailTemplate.body }}
              ></div>
            </div>
          </div>
          <div className="flex justify-end gap-4">
            <button type="button" onClick={onClose} className="gothic-button">Cancel</button>
            <button type="submit" className="gothic-button gothic-button-primary">Create</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateMailTemplateModal;
